// extracted by css-extract-rspack-plugin
export default {"row":"PersonalResult__row--C0Z31","actions":"PersonalResult__actions--aKHdr"};